let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cgB5I")).then(() => parcelRequire('lWfml'));